import React, { useEffect, useState } from 'react'
import { Wrench } from 'phosphor-react'
import { MaintenanceService } from 'utility'
import { MaintenanceTaskDetailModal } from './MaintenanceTaskDetailModal'
import { LINK_ROLE_LABELS } from './maintenance-utils'

const ROLE_TEXT = {
    Work: 'Work checklist of',
    Source: 'Source of',
    PreInspection: 'Pre-inspection of',
    PostInspection: 'Verification of',
}

/**
 * Inspection page (EAUDITOR-407): "This inspection is the work checklist / source / pre / post inspection of
 * maintenance task X" with a link to the task. Renders nothing when there is none or the call fails.
 */
export const InspectionMaintenanceBanner = ({ auditId }) => {
    const [rows, setRows] = useState([])
    const [openTaskId, setOpenTaskId] = useState(null)

    useEffect(() => {
        let alive = true
        setRows([])
        const id = Number(auditId)
        if (!Number.isInteger(id) || id <= 0) return undefined
        MaintenanceService.byAudit(id)
            .then(result => {
                if (alive) setRows(Array.isArray(result) ? result : [])
            })
            .catch(() => {
                if (alive) setRows([])
            })
        return () => {
            alive = false
        }
    }, [auditId])

    if (!rows.length) return null

    return (
        <div
            style={{
                margin: '12px 16px 0',
                padding: '10px 14px',
                background: '#ecfdf9',
                border: '1px solid #99d5cf',
                borderRadius: 8,
                color: '#134e4a',
                fontSize: 13,
            }}
        >
            {rows.map(row => (
                <div key={`${row.TaskId}-${row.Role}`} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <Wrench size={14} weight="bold" />
                    <span title={LINK_ROLE_LABELS[row.Role] || ''}>
                        {ROLE_TEXT[row.Role] || 'Linked to'} maintenance task
                    </span>
                    <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ fontSize: 13, fontWeight: 600 }}
                        onClick={() => setOpenTaskId(row.TaskId)}
                    >
                        {row.Title}
                    </button>
                    <span style={{ color: '#4b5563' }}>
                        {[row.AssetName, row.StageName].filter(Boolean).join(' · ')}
                    </span>
                </div>
            ))}
            <MaintenanceTaskDetailModal
                open={!!openTaskId}
                taskId={openTaskId}
                onClose={() => setOpenTaskId(null)}
            />
        </div>
    )
}
